/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: Prenatal_Appeal_Data.jsx
 *  @description: Этот файл является частью клиентской стороны проекта. Относится к части, которая содержит компоненты - части страниц, допускающие многократное использование в разных частях. Категория "лучевая диагностика". Компонент для отрисовки отдельного обращения пациента. Обращение может включать в себя несколько исследований.
 *	@author: Белов Михаил Александрович, Манжос Геннадий Юрьевич
*/
import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Context } from "../../index";
import { Spinner } from 'react-bootstrap';

import SliderProtected from '../ProtectedImageSlider';
import VideoPlayer from '../VideoPlayer';

import './Prenatal_Appeal_Block.css';

//  Блок с информацией об обращении пациента.
//  Здесь необходимо вывести:
//  *   номер обращения,
//  *   анамнез,
//  *   лаб. показатели,
//  *   лечение (если проводилось),
//  Также, необходимо вывести все относящиеся к этому обращению проведённые исследования.
const Prenatal_Appeal_Block = observer(({ data }) => {
    const { user } = useContext(Context);
    const { t } = useTranslation();

    const [ descriptionIndex, setDescriptionIndex ] = useState(0);

    let imageDescription = data['images_' + user.language][descriptionIndex];
    if (imageDescription === '')
        imageDescription = null;

    if (!data)
        return;

    return <div className='prenatal_appeal_block'>
        <div className='prenatal_appeal_anamnesis'>
            <div className='title'>{t('description')}</div>
            <div className='text'>{data['description_' + user.language] ?? t('prenatal_no_content')}</div>
        </div>

        <br />

        <div className='prenatal_examination_images'>
            {(data?.images_paths?.[descriptionIndex]?.endsWith('.avi') || data?.images_paths?.[descriptionIndex]?.endsWith('.mp4')) ? <div style={{ marginBottom: '2rem' }}>
                <VideoPlayer category='prenatal' id={data.id} idx={descriptionIndex} />
            </div> : <>
                <SliderProtected imageurl={data.images_paths} imagesPerView={1} onSlideChanged={ i => setDescriptionIndex(i) } />
            </>}
        </div>

        <div className='prenatal_appeal_anamnesis'>
            <div className='title'>{t('description')}</div>
            <div className='text'>{imageDescription ?? t('prenatal_no_content')}</div>
        </div>

        <div className='prenatal_appeal_labdiag'>
            <div className='title'>{t('conclusion')}</div>
            <div className='text'>{data['conclusion_' + user.language] ?? t('prenatal_no_content')}</div>
        </div>

    </div>;
});

export default Prenatal_Appeal_Block;